import axios from 'axios'

const request = axios.create({
  baseURL: '/dashboard/editor/api',
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

export default request
